import styled from 'styled-components';
import { darken } from 'polished';

// CONSTANTS
import { ROYAL_BLUE_2, WHITE } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.div`
  border-radius: 12px;
  overflow: hidden;
  background-color: ${p => p.theme.palette.home.left || ROYAL_BLUE_2};
  color: ${p => p.theme.palette.home.leftText || WHITE};
  display: flex;

  ${breakpoints.down('xs')} {
    flex-direction: column;
    margin-right: -15px;
    margin-left: -15px;
    border-radius: 0;
  }

  .banner {
    &__section-left {
      padding: 24px;

      flex: 1;

      ${breakpoints.down('xs')} {
        padding: 32px;

        order: 2;
      }
    }

    &__section-right {
      position: relative;
      display: flex;
      align-items: center;
      padding: 16px;
      justify-content: center;
      width: 387px;
      flex-shrink: 0;
      flex-wrap: wrap;

      ${breakpoints.down(1200)} {
        width: 350px;
      }

      ${breakpoints.down('sm')} {
        width: 320px;
      }

      ${breakpoints.down('xs')} {
        width: 100%;
      }

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: ${p => {
          const homeColor = p.theme.palette.home.left;

          return p.theme.partnerStyles && homeColor
            ? darken(0.1, homeColor)
            : `linear-gradient(99.73deg, #2d30f8 0%, #1572ff 99.99%, #2325da 100%)`;
        }};
        opacity: 0.66;
        box-shadow: inset 4px 4px 12px rgba(18, 23, 52, 0.15);
        z-index: 1;
      }
    }

    &__title,
    &__subtitle {
      ${breakpoints.down('xs')} {
        text-align: center;
      }
    }

    &__btns-wrapper {
      > :not(:last-child) {
        margin-right: 24px;

        ${breakpoints.down('xs')} {
          margin-right: 0;
          margin-bottom: 15px;
        }
      }

      .banner__btn {
        ${breakpoints.down('xs')} {
          width: 100%;
        }
      }
    }

    &__btn {
      min-width: 255px;
    }
  }
`;

export default Container;
